<template>
  <div class="modal fade" id="fetchOverages" tabindex="-1" role="dialog" aria-labelledby="fetchAndAddFromHostBill" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Disk Overage</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="fetchDetails">
            <div class="row">
              <div class="col-md-6">
                <label>Select plan to fetch disk overage details.</label>
                <select class="form-control h-43" required v-model="selectedDomain">
                  <option :value="null" disabled>Select Plan</option>
                  <option :value="account.primary.domain" v-for="(account, index) of realHostingAccounts" v-if="account.primary.domain"  :key="index">{{ account.primary.domain }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Select Month</label>
                <select class="form-control h-43" required v-model="selectedMonth">
                  <option :value="null" disabled>Select Month</option>
                  <option :value="month.value" v-for="(month, index) of months" :key="index">{{ month.name }}</option>
                </select>
              </div>
              <div class="col-md-12">
                <button type="submit" class="btn btn-info btn-md mt-4 pull-right">
                  Fetch
                </button>
              </div>
            </div>

          </form>
          <div class="loader" v-if="loading"></div>
          <div v-else-if="record">
            <div class="row mt-5 text-primary">
              <div class="col-md-6 ">
                <h3>Total disk Usage:
                  <small>{{ record.currentStats.total.value + ' ' + record.currentStats.total.unit }}</small>
                </h3>
              </div>
              <div class="col-md-6">
                <h3>Total Cost:
                  <small>{{ '$ ' + record.totalCost  }}</small></h3>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table manual_backup">
                <thead class="text-primary">
                  <tr>
                    <th>Day</th>
                    <th>Total Usage</th>
                    <th>Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(unit, index) of record.billingUnits" :key="index">
                    <td>{{ unit.day }}</td>
                    <td>{{ (unit.total) ? unit.total.value + ' ' + unit.total.unit : 'N/A' }}</td>
                    <td>$ {{ unit.cost }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div v-if="!record.invoiceId"  class="col-md-12">
                <button type="button" class="btn btn-info btn-md" @click="addNewInvoice">
                  SUBMIT INVOICE AS DRAFT
                </button>
              </div>
              <div v-else-if="!record.finalized" class="col-md-12">
                <button type="button" class="btn btn-info btn-md" @click="finalize">
                  FINALIZE THIS INVOICE
                </button>
              </div>
              <div v-else class="col-md-12">
                <b>Invoice has been created and finalized.</b><br>
                <b>Invoice ID: </b>{{record.invoiceId}}
              </div>
            </div>
          </div>
          <div v-else class="text-center p-5">
            <span class="text-center text-danger">No Data to show here</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  name: "fetchOverages",
    data () {
      return {
        loading: false,
        selectedDomain: null,
        selectedMonth: null,
        record: null,
        months: [
            {
                name: 'January',
                value: 1
            },
            {
                name: 'February',
                value: 2
            },
            {
                name: 'March',
                value: 3
            },
            {
                name: 'April',
                value: 4
            },
            {
                name: 'May',
                value: 5
            },
            {
                name: 'June',
                value: 6
            },
            {
                name: 'July',
                value: 7
            },
            {
                name: 'August',
                value: 8
            },
            {
                name: 'September',
                value: 9
            },
            {
                name: 'October',
                value: 10
            },
            {
                name: 'November',
                value: 11
            },
            {
                name: 'December',
                value: 12
            }
        ]
      }
    },
    computed: {
      docID() {
        return this.$store.getters["customer/docID"];
      },
      realHostingAccounts() {
        return this.$store.getters["hosting/accounts"];
      },
      custID() {
        return this.$store.getters["customer/id"];
      },
    },
    methods: {
      load() {
        $("#fetchOverages").modal('show')
        this.record = null
        this.selectedDomain = null
        this.selectedMonth = null
        this.loading = false
      },
      async fetchDetails () {
        this.loading = true
        try {
          const resp = await this.$http.post('disk/get-overages-data', {
            grant_type: 'token',
            uid: this.docID,
            domain: this.selectedDomain,
            month: this.selectedMonth,
          });
            console.log(resp.data)
            this.record = resp.data
            if (!this.record.invoiceId) {
                this.record.invoiceId = ''
            }
        } catch (e) {
          console.log(e.toString())
        }
        this.loading = false
      },
      async finalize () {
        this.loading = true
        try {
          await this.$http.post('disk/convert-invoice', {
            grant_type: 'token',
            uid: this.docID,
            billingId: this.record.id
          });
          this.record.finalized = true
          swal('Success!', 'Invoice has been finalized successfully!', 'success');
        } catch (e) {
          console.log(e.toString())
          swal('Error!', e.toString(), 'error');
        }
        this.loading = false
      },
      async addNewInvoice () {
        this.loading = true
        try {
          const resp = await this.$http.post('disk/add-invoice', {
            grant_type: 'token',
            uid: this.docID,
            clientId: this.custID,
            billingId: this.record.id
          });
          this.record.invoiceId = resp.data.invoice_id
          swal('Success!', 'Invoice has been created and all items has been added successfully!', 'success');
        } catch (e) {
          console.log(e.toString())
          swal('Error!', e.toString(), 'error');
        }
        this.loading = false
      },
      async addInvoiceItems () {
        this.loading = true
        try {
          const resp = await this.$http.post('disk/add-all-invoice-items', {
            grant_type: 'token',
            uid: this.docID,
            billingId: this.record.id
          });
         console.log(resp.data)
        } catch (e) {
          console.log(e.toString())
        }
        this.loading = false
      }
    }
  }
</script>

<style scoped>

</style>
